/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_WithdrawalInputs */

const de_commons_footer_withdrawal = /** @type {(inputs: Commons_Footer_WithdrawalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widerruf`)
};

/** @type {(inputs: Commons_Footer_WithdrawalInputs) => LocalizedString} */
const en_commons_footer_withdrawal = de_commons_footer_withdrawal;

/**

* @param {Commons_Footer_WithdrawalInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_withdrawal = /** @type {((inputs?: Commons_Footer_WithdrawalInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_WithdrawalInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_withdrawal(inputs)
	return en_commons_footer_withdrawal(inputs)
});